import { render } from "./OrgManagement.vue?vue&type=template&id=620509c2"
import script from "./OrgManagement.vue?vue&type=script&lang=js"
export * from "./OrgManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__